import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import documentsService from "services/documents.service";
import { handleSnackBar } from "./global";
import MESSAGES from "constants/messages";

export const fetchAllDocuments = createAsyncThunk(
  "notifications/readAll",
  async ({ page }: { page: number }, { dispatch }) => {
    try {
      const resp = await documentsService.fetchAll({ body: { page } });
      return resp?.data?.data || {};
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const documentsSlice = createSlice({
  name: "docuemnts",
  initialState: {
    page: 1,
    list: [] as Array<any>,
    listMeta: {},
    ownerResources: [],
    insuranceBookingForms: [],
  },
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(fetchAllDocuments.fulfilled, (state, { payload }: any) => {
      if (payload?.list) {
        state.list = payload.list;
        state.listMeta = payload.meta;
      } else {
        state.list = [];
        state.listMeta = {};
      }

      state.insuranceBookingForms = payload?.documents?.insurance_booking_forms;
      state.ownerResources = payload?.documents?.owner_resources;
    }),
});

export default documentsSlice.reducer;
